import { Pagination } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import { Link } from "react-router-dom";
import { convertSlote, formatDateFunction, getTabFromOrderStatus } from "../../../../utils/helper/utils";

const LateOrdersReports = ({ inputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [totalRows, setTotalRows] = useState(0);

  const getAllReportsByLateOrder = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_LATE_ORDERS, "get", {}, { params }, true);
      let apiResponse = response?.data;

      if (response?.status === 200 && apiResponse?.status === "SUCCESS") {
        const apiData = apiResponse?.data?.lateOrderData || [];
        const paginator = apiResponse?.data?.paginator || {};
        setList(apiData);
        setList(apiData);
        setTotalRows(paginator?.totalItems || 0);
        
      } else {
        toast.error(apiResponse?.message || "Failed to fetch data");
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByLateOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full text-left text-sm text-gray-500">
          <thead className="text-gray-700 capitalize text-xs bg-gray-50">
            <tr>
              <th className="px-3 py-3 whitespace-nowrap">Order Number</th>
              <th className="px-3 py-3 whitespace-nowrap">Branch Name</th>
              <th className="px-3 py-3 whitespace-nowrap">Driver Name</th>
              <th className="px-3 py-3 whitespace-nowrap">Order Type</th>
              <th className="px-3 py-3 whitespace-nowrap">Delivery Mode</th>
              <th className="px-3 py-3 whitespace-nowrap">Dropzone</th>
              <th className="px-3 py-3 whitespace-nowrap">Zone</th>
              <th className="px-3 py-3 whitespace-nowrap">Payment Method</th>
              <th className="px-3 py-3 whitespace-nowrap">Total Amount</th>
              <th className="px-3 py-3 whitespace-nowrap">Order Date</th>
              <th className="px-3 py-3 whitespace-nowrap">Delivery Date</th>
              <th className="px-3 py-3 whitespace-nowrap">Time Slot</th>
              <th className="px-3 py-3 whitespace-nowrap">Actual Delivery Date</th>
            </tr>
          </thead>

          <tbody>
            {list && list.length > 0 ? (
              list.map((item, index) => (
                <tr key={index} className="bg-white border-b">
                  <td className="px-3 py-4 whitespace-nowrap">
                    <Link
                      className="cursor-pointer"
                      to={`/order-management/?order_number=${item?.orderNumber}`}
                      state={{
                        orderNumber: item?.orderNumber,
                        activeTab: getTabFromOrderStatus(item?.status)
                      }}
                      style={{ color: "#37846B", fontWeight: 500 }}
                    >
                      {item?.orderNumber}
                    </Link>
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.branchName || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.driverName || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.orderType || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.deliveryMode || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.dropZone || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.zone || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {item?.paymentMethod === "cod"
                      ? "N/A"
                      : item?.paymentMethod === "credit_card"
                      ? "Credit Card"
                      : item?.paymentMethod === "apple_pay"
                      ? "Apple Pay"
                      : "N/A"}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {item?.totalAmount ? `${item?.totalAmount} SAR` : "0 SAR"}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.orderDate || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.deliveryDate || "N/A"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {item?.scheduledTime 
                      ? item.scheduledTime.split(" - ").map(time => convertSlote(time.trim())).join(" - ")
                      : "N/A"
                    }
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {/* {item?.actualDeliveryDate} */}
                    {formatDateFunction(item?.actualDeliveryDate, "yyyy-mm-dd", true, "at")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={13} className="text-center py-6">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {list?.length > 0 && (
        <div className="text-right mt-4">
          <Pagination
            defaultCurrent={1}
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger
            current={paginationModel?.page}
            pageSize={paginationModel?.limit}
            onChange={(page) => setPaginationModel((prev) => ({ ...prev, page }))}
            onShowSizeChange={(current, size) =>
              setPaginationModel((prev) => ({ ...prev, limit: size, page: 1 }))
            }
          />
        </div>
      )}
    </>
  );
};

export default LateOrdersReports;